(function(){
	'use strict';

	angular
	.module('app.products')
	.controller('ProductController', ProductController);

	function ProductController(API, apiConfig, $filter) {
		let vm = this;
		vm.listProducts = [];

		vm.$onInit = () => {
		  _loadFromApi();
		}

		function _loadFromApi() {
		  _loadProducts();
		}

		function _loadProducts() {
		  API.get('produto_brastelha')
				.then(result => result.data)
				.then(products => vm.listProducts = products.map(product => {
		          product.image = $filter('imgUrl')(product.imagem_produto);
		          return product;
		        }).filter(product => {
		        	return product.slug_categoria.toUpperCase() != 'BRAS-X'
		        })
		        )
				.catch(error => {
				  console.error(error, 'error');
				});
		}
	}

})();
